import { css } from "@vitality-ds/system";
import { colorUseCases, getColorScaleValueByUseCase } from "@vitality-ds/tokens";
var text = colorUseCases.text;
export default css({
  border: 0,
  backgroundColor: "transparent",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  color: getColorScaleValueByUseCase("neutral", text.lowContrast)
});